// extracted by mini-css-extract-plugin
export default {"last-updated":"lastupdated-module_last-updated_rSxL6VYk"};